<template>
    <md-dialog
            :md-click-outside-to-close="false"
            :md-close-on-esc="false"
            @keydown.esc="updateIsRequestCreating"
            v-bind:class="{ supp_dd: supplement_dd_only }"
            :md-active.sync="show_create_request">
        <md-toolbar>
            <div class="md-title md-layout md-gutter md-alignment-center-center" style="width: inherit">
                <div v-if="!supplement_dd_only" class="md-layout-item">
                    Create New Porting Request
                </div>
                <div v-if="supplement_dd_only" class="md-layout-item">
                    Supplement Port Date
                </div>
                <div class="md-layout md-alignment-center-right">
                    <md-button class="md-primary md-layout-item md-size-10"
                               @click="updateIsRequestCreating"
                               :md-ripple="false">
                        <md-icon>close</md-icon>
                    </md-button>
                </div>
            </div>
        </md-toolbar>
        <md-dialog-content>
            <form novalidate class="md-layout" style="display: block">
                <md-card style="flex: 1" v-if="!supplement_dd_only" v-loading="current_requests.length === 0">
                    <md-card-header style="background-color: rgb(244, 244, 244); font-size: 16px;">Account details
                    </md-card-header>
                    <md-card-content style="padding-block-end: 30px">
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item">
                                <md-field id="customer_name" :class="getValidationClass('customer_name')">
                                    <label for="customer_name">Customer Name</label>
                                    <md-input v-model="form.customer_name"
                                              :disabled="executing_request_add"
                                              name="customer_name"
                                              required
                                    ></md-input>
                                    <span class="md-error" v-if="!$v.form.customer_name.required">The customer name is required</span>
                                    <span class="md-error" v-else-if="!$v.form.customer_name.alpha_spaces">Should contains only alphabet characters and spaces</span>
                                </md-field>
                            </div>
                            <div class="md-layout-item">
                                <el-tooltip :tabindex="-1" :disabled="btn_tooltip_disabled"
                                            content="Main phone number associated with the account or the number to be ported"
                                            placement="top" effect="light">
                                    <md-field id="billing_telephone_number"
                                              :class="getValidationClass('billing_telephone_number')">
                                        <label for="billing_telephone_number">Billing telephone number</label>
                                        <md-input v-model="form.billing_telephone_number"
                                                  @focusin="btn_tooltip_disabled = true"
                                                  @focusout="btn_tooltip_disabled = false"
                                                  required
                                                  :disabled="executing_request_add"
                                                  name="billing_telephone_number"></md-input>
                                        <span class="md-error" v-if="!$v.form.billing_telephone_number.required">The billing telephone number is required</span>
                                        <span class="md-error"
                                              v-else-if="!$v.form.billing_telephone_number.phonenumber">Should be a phone number in E.164 format</span>
                                    </md-field>
                                </el-tooltip>
                            </div>
                            <md-field id="customer_country" class="md-layout-item md-size-40"
                                      :class="getValidationClass('customer_country')"
                                      style="margin-right: 20px"
                            >
                                <label for="customer_country">Customer Country</label>
                                <md-select v-model="form.customer_country"
                                           required
                                           :disabled="executing_request_add"
                                           name="customer_country">
                                    <md-option
                                            v-for="item in countries" v-bind:key="item"
                                            :value="item">
                                        {{ item }}
                                    </md-option>
                                </md-select>
                                <span class="md-error" v-if="!$v.form.customer_country.required">The customer country is required</span>
                            </md-field>
                        </div>
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item">
                                <md-field id="customer_street1" :class="getValidationClass('customer_street1')">
                                    <label for="customer_street1">Customer Street</label>
                                    <md-input v-model="form.customer_street1"
                                              required
                                              :disabled="executing_request_add"
                                              name="customer_street1"></md-input>
                                    <span class="md-error" v-if="!$v.form.customer_street1.required">The customer street is required</span>
                                    <span class="md-error" v-else-if="!$v.form.customer_street1.alpha_num_spaces">Should contains only alphanumeric characters and spaces</span>
                                </md-field>
                            </div>
                            <div class="md-layout-item">
                                <md-field id="customer_street2" :class="getValidationClass('customer_street2')">
                                    <label for="customer_street2">Customer Street 2</label>
                                    <md-input v-model="form.customer_street2"
                                              :disabled="executing_request_add"
                                              name="customer_street1"></md-input>
                                    <span class="md-error" v-if="!$v.form.customer_street2.customer_street2">Should contains only alphanumeric characters and spaces</span>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item">
                                <md-field id="customer_city" required :class="getValidationClass('customer_city')">
                                    <label for="customer_city">Customer City</label>
                                    <md-input v-model="form.customer_city"
                                              name="customer_city"
                                              :disabled="executing_request_add"
                                              required
                                    ></md-input>
                                    <span class="md-error" v-if="!$v.form.customer_city.required">The customer city is required</span>
                                    <span class="md-error" v-else-if="!$v.form.customer_city.alpha_spaces">Should contains only alphabet characters and spaces</span>
                                </md-field>
                            </div>
                            <div class="md-layout-item">
                                <md-field id="customer_state" :class="getValidationClass('customer_state')">
                                    <label for="customer_state">Customer State</label>
                                    <md-input v-model="form.customer_state"
                                              :required="form.customer_country === 'United States'"
                                              :disabled="executing_request_add"
                                              name="customer_state"></md-input>
                                    <span class="md-error" v-if="!$v.form.customer_state.customer_state">Required and should contains only alphabet characters and spaces</span>
                                </md-field>
                            </div>
                            <div class="md-layout-item">
                                <md-field id="customer_zip" :class="getValidationClass('customer_zip')">
                                    <label for="customer_zip">Customer Zip</label>
                                    <md-input v-model="form.customer_zip"
                                              :required="form.customer_country === 'United States'"
                                              :disabled="executing_request_add"
                                              name="customer_zip"></md-input>
                                    <span class="md-error" v-if="!$v.form.customer_zip.customer_zip">Required and should contains only numeric values</span>
                                </md-field>
                            </div>
                        </div>
                    </md-card-content>
                </md-card>
                <md-card v-if="!supplement_dd_only" style="flex: 1; margin-top: 10px"
                         v-loading="current_requests.length === 0">
                    <md-card-header style="background-color: rgb(244, 244, 244); font-size: 16px;">Phone Number(s) to
                        Port
                    </md-card-header>
                    <md-card-content style="padding-block-end: 30px">
                        <div class="md-layout md-gutter" v-if="!supplement_dd_only">
                            <div class="md-layout-item" style="padding: 10px">
                                <md-field id="phone_numbers" :class="getValidationClass('phone_numbers')">
                                    <label for="phone_numbers">Phone Number(s) to Port</label>
                                    <md-textarea
                                            :disabled="executing_request_add"
                                            v-model="form.phone_numbers"
                                            required
                                    ></md-textarea>
                                    <span class="md-error" v-if="!$v.form.phone_numbers.required">At least one phone number is required</span>
                                    <span class="md-error" v-else-if="!$v.form.phone_numbers.phonenumbers_list">Should contains only phone numbers in E.164 format starting with "1" and split by spaces or commas</span>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout md-gutter">
                            <div v-if="!supplement_dd_only" class="md-layout-item md-size-50" id="file"
                                 :class="getValidationClass('file')">
                                <label for="file"
                                       :class="!$v.form.file.file ? 'error_label' : 'normal_label'">Letter
                                    of Authorization
                                    *</label>
                                <el-upload
                                        action=""
                                        style="padding: 3px"
                                        :on-preview="previewFile"
                                        :file-list="uploaded_file"
                                        :disabled="executing_request_add"
                                        :auto-upload="false"
                                        :on-remove="onFileRemove"
                                        :on-change="onFileChange">
                                    <i class="el-icon-upload"></i>
                                    <el-button size="medium" type="primary" :disabled="executing_request_add">Upload
                                        Letter of Authorization
                                    </el-button>
                                    <div class="el-upload__tip" slot="tip" style="padding-left: 15px">
                                    </div>
                                </el-upload>
                                <span class="md-error" style="font-size: 12px; color: #ff1744"
                                      v-if="!$v.form.file.file">Letter of Authorization is required</span>
                            </div>
                            <div class="md-layout-item md-size-50" id="requested_foc_date"
                                 :class="getValidationClass('requested_foc_date')">
                                <div style="display: grid">
                                    <label for="requested_foc_date"
                                           :class="(!$v.form.requested_foc_date.required || !$v.form.requested_foc_date.requested_foc_date) ? 'error_label' : 'normal_label'">Requested
                                        Port Date *</label>
                                    <el-date-picker
                                            v-model="form.requested_foc_date"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            :disabled="executing_request_add"
                                            placeholder="Requested Port Date"
                                            :picker-options="pickerOptions">
                                    </el-date-picker>
                                    <span class="md-error" style="font-size: 12px; color: #ff1744"
                                          v-if="!$v.form.requested_foc_date.required">Requested Port Date is required</span>
                                    <span class="md-error" style="font-size: 12px; color: #ff1744"
                                          v-else-if="!$v.form.requested_foc_date.requested_foc_date">Requested Port Date should be at least {{ min_foc_date }} days later than today</span>
                                </div>
                            </div>
                        </div>
                    </md-card-content>
                </md-card>
                <div v-if="supplement_dd_only" v-loading="current_requests.length === 0"
                     class="md-layout md-alignment-center-left" style="padding-left: 20px" id="foc_date"
                     :class="getValidationClass('requested_foc_date')">
                    <div style="display: grid">
                        <label for="foc_date"
                               :class="(!$v.form.requested_foc_date.required || !$v.form.requested_foc_date.requested_foc_date) ? 'error_label' : 'normal_label'">Requested
                            Port Date *</label>
                        <el-date-picker
                                v-model="form.requested_foc_date"
                                type="date"
                                value-format="yyyy-MM-dd"
                                :disabled="executing_request_add"
                                placeholder="Requested Port Date"
                                :picker-options="pickerOptions">
                        </el-date-picker>
                        <span class="md-error" style="font-size: 12px; color: #ff1744"
                              v-if="!$v.form.requested_foc_date.required">Requested Port Date is required</span>
                        <span class="md-error" style="font-size: 12px; color: #ff1744"
                              v-else-if="!$v.form.requested_foc_date.requested_foc_date">Requested Port Date should be at least 7 days later than today</span>
                    </div>
                </div>
               <div v-if="supplement_dd_only" v-loading="current_requests.length === 0"
                     class="md-layout md-alignment-center-left" style="padding-left: 20px">
                      <md-field id="dd_comment" style="margin-block-start: 20px;">
                          <label for="dd_comment">Comments</label>
                          <md-textarea
                              :disabled="executing_request_add"
                              v-model="form.comment"
                          ></md-textarea>
                      </md-field>
                </div>
                <md-card v-if="!supplement_dd_only" style="flex: 1; margin-top: 10px">
                    <md-card-header style="background-color: rgb(244, 244, 244); font-size: 16px;">Comments
                    </md-card-header>
                    <md-card-content>
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item" style="padding-top: 10px;">
                                <md-field id="comment" >
                                    <label for="comment">Comments</label>
                                    <md-textarea
                                            :disabled="executing_request_add"
                                            v-model="form.comment"
                                    ></md-textarea>
                                </md-field>
                            </div>
                        </div>
                    </md-card-content>
                </md-card>
            </form>
        </md-dialog-content>
        <md-dialog-actions class="md-layout" style="margin: 5px">
            <el-button
                    class="md-size-25 md-layout-item"
                    :disabled="executing_request_add"
                    @click="updateIsRequestCreating"
                    type="danger"
            >Cancel
            </el-button>
            <el-button
                    class="md-size-25 md-layout-item"
                    :disabled="current_requests.length === 0"
                    :loading="executing_request_add"
                    @click="validateRequest"
                    type="success"
            >Submit
            </el-button>
        </md-dialog-actions>
    </md-dialog>
</template>

<script>
    import {mapState} from "vuex";
    import {validationMixin} from 'vuelidate';
    import {
        required,
        numeric,
    } from 'vuelidate/lib/validators';
    import {
        alpha_spaces,
        alpha_num_spaces,
        phonenumber,
        phonenumbers_list
    } from '../utils/validators';
    import {
        MIN_FOC_DATE
    } from '../utils/constants';

    export default {
        name: "RequestCreateView",
        mixins: [validationMixin],
        props: ['show_create_request', 'porting_order_id', 'supplement_dd_only'],
        data() {
            return {
                min_foc_date: MIN_FOC_DATE,
                btn_tooltip_disabled: false,
                form: {
                    billing_telephone_number: '',
                    phone_numbers: '',
                    requested_foc_date: "",
                    customer_name: '',
                    customer_country: 'United States',
                    customer_street1: '',
                    customer_street2: '',
                    customer_city: '',
                    customer_state: '',
                    customer_zip: '',
                    file: "",
                    comment: "",
                },
                uploaded_file: [],
                old_file_used: true,
                pickerOptions: {
                    disabledDate(time) {
                        let firstAvailableDate = new Date();
                        firstAvailableDate.setDate(firstAvailableDate.getDate() + MIN_FOC_DATE);
                        return time.getTime() < firstAvailableDate;
                    },
                }
            }
        },
        validations: {
            form: {
                customer_name: {
                    required,
                    alpha_spaces
                },
                customer_country: {
                    required
                },
                billing_telephone_number: {
                    required,
                    phonenumber
                },
                customer_street1: {
                    required,
                    alpha_num_spaces
                },
                customer_street2: {
                    customer_street2: function (value) {
                        if (!value) return true;
                        return alpha_num_spaces(value)
                    }
                },
                customer_city: {
                    required,
                    alpha_spaces
                },
                customer_state: {
                    customer_state: function (value, vm) {
                        if (vm.customer_country === "United States") {
                            return value && alpha_spaces(value)
                        }
                        else {
                            return true;
                        }
                    }
                },
                customer_zip: {
                    customer_state: function (value, vm) {
                        if (vm.customer_country === "United States") {
                            return value && numeric(value)
                        }
                        else {
                            return true;
                        }
                    }
                },
                phone_numbers: {
                    required,
                    phonenumbers_list
                },
                file: {
                    file: function () {
                        return this.form.file || this.old_file_used || this.uploaded_file.length !== 0;
                    }
                },
                requested_foc_date: {
                    required,
                    requested_foc_date: function (value) {
                        let firstAvailableDate = new Date();
                        firstAvailableDate.setDate(firstAvailableDate.getDate() + MIN_FOC_DATE);
                        return new Date(value) >= firstAvailableDate;
                    }
                },
            }

        },
        methods: {
            getValidationClass(fieldName) {
                const field = this.$v.form[fieldName]

                if (field) {
                    return {
                        'md-invalid': field.$invalid && field.$dirty
                    }
                }
            }
            ,
            previewFile() {
                window.open(this.uploaded_file[0].url, "_blank");
            },
            onFileRemove() {
                this.old_file_used = false;
                this.form.file = null
                this.uploaded_file = []
                //this.$v.$touch()
            }
            ,
            onFileChange(file) {
                this.old_file_used = false;
                this.form.file = file;
                this.uploaded_file = [{name: file.name, url: URL.createObjectURL(file.raw)}]
            }
            ,
            updateIsRequestCreating: function () {
                this.$emit('update:show_create_request', !this.show_create_request)
            }
            ,
            validateRequest() {
                this.$v.$touch()

                if (!this.$v.$invalid || (this.supplement_dd_only && !this.$v.form.requested_foc_date.$invalid)) {
                    let data = new FormData();
                    data.append('porting_order_id', this.porting_order_id);
                    data.append('requested_foc_date', this.form.requested_foc_date);
                    data.append('BTN', this.form.billing_telephone_number);
                    data.append('phone_numbers', this.form.phone_numbers);
                    data.append('requested_foc_date', this.form.requested_foc_date);
                    data.append('customer_name', this.form.customer_name.trim());
                    data.append('customer_country', this.form.customer_country.trim());
                    data.append('customer_street1', this.form.customer_street1.trim());
                    data.append('customer_street2', this.form.customer_street2.trim());
                    data.append('customer_city', this.form.customer_city.trim());
                    data.append('customer_state', this.form.customer_state.trim());
                    data.append('customer_zip', this.form.customer_zip.trim());
                    data.append('comments', this.form.comment.trim());
                    if (!this.old_file_used) {
                        data.append('file', this.form.file.raw, this.form.file.name);
                    }

                    this.$store.dispatch('orders/addRequest', data)
                }
            }
            ,
            clearForm() {
                this.form = {
                    billing_telephone_number: '',
                    phone_numbers: '',
                    requested_foc_date: null,
                    customer_name: '',
                    customer_country: 'United States',
                    customer_street1: '',
                    customer_street2: '',
                    customer_city: '',
                    customer_state: '',
                    customer_zip: '',
                    file: null,
                    comment: '',
                }
                this.uploaded_file = [];
                this.$v.$reset()
            }
            ,
            populateForm() {
                this.form.billing_telephone_number = this.current_requests[0].billing_telephone_number;
                this.form.customer_country = (this.countries && this.current_requests[0].customer_country && this.countries.includes(this.current_requests[0].customer_country)) ? this.current_requests[0].customer_country : "United States";
                this.form.customer_city = this.current_requests[0].customer_city;
                this.form.customer_name = this.current_requests[0].customer_name;
                this.form.customer_state = this.current_requests[0].customer_state;
                this.form.customer_street1 = this.current_requests[0].customer_street1;
                this.form.customer_street2 = this.current_requests[0].customer_street2;
                this.form.customer_zip = this.current_requests[0].customer_zip;
                this.form.phone_numbers = this.current_requests[0].phone_numbers;
                this.form.requested_foc_date = this.current_requests[0].requested_foc_date;
                this.form.comment = this.current_requests[0].comment || "";
                this.uploaded_file = [{
                    name: this.current_requests[0].loa_filename,
                    url: this.current_requests[0].loa_url
                }];
                //this.$v.$touch()
            }
        }
        ,
        computed: {
            ...
                mapState({
                    user: state => state.auth.user,
                    countries: state => state.autocomplete.countries,
                    executing_request_add: state => state.orders.executing_request_add,
                    notification: state => state.orders.notification,
                    show_request_notification: state => state.orders.show_request_notification,
                    current_requests: state => state.orders.current_requests,
                }),
        }
        ,
        watch: {
            executing_request_add: function (newVal, oldVal) {
                if (newVal === false && oldVal === true && this.notification.type === 'success') {
                    this.updateIsRequestCreating()
                    this.$store.dispatch('orders/setCurrentRequests', [])
                    this.clearForm();
                }
            }
            ,
            show_create_request: function (newVal, oldVal) {
                if (oldVal === false && newVal === true) {
                    this.$v.$reset()
                    this.$store.dispatch('orders/getRequests', {porting_order_id: this.porting_order_id})
                } else {
                    this.$store.dispatch('orders/setCurrentRequests', [])
                    this.clearForm();
                }
            }
            ,
            current_requests: function (newVal) {
                if (newVal.length > 0) {
                    this.populateForm();
                }
            }
        }
        ,
    }
</script>

<style scoped>
    .md-dialog {
        min-width: 70%;
        max-width: 95%;
    }

    .supp_dd {
        width: 50%;
        min-width: 50%;
        max-width: 95%;
    }

    .md-dialog /deep/ .md-dialog-container {
        transform: none;
    }

    .md-dialog /deep/ .md-dialog-content {
        padding: 5px;
    }

    .md-card-content:last-of-type {
         padding-bottom: 10px !important;
    }

    .md-list-item {
        height: 65px;
    }

    form {
        padding: 10px;
    }

    .el-input /deep/ .el-input__inner {
        border-color: gray
    }

    .el-input /deep/ .el-input__prefix {
        color: gray
    }

    .error_label {
        color: rgb(255, 23, 68);
        font-size: 12px;
    }

    .normal_label {
        color: rgba(0, 0, 0, 0.54);
        font-size: 12px;
    }

    button {
        font-weight: 500;
    }

</style>